import { Link, Route, Routes, useLocation, useParams } from "react-router-dom";
import { useState, useEffect, Suspense, lazy } from "react";
import "./App.scss";
import { Category, Footer, Preloader } from "./components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ScrollToTop, useToFindItem } from "./services/data_requests";
import {
  Fashion,
  FashionTool,
  Legal,
  Media,
  Letter,
  Galllary,
} from "./routes";
import { appRoutes } from "./routesConfig";
import CertificateTool from "./routes/CertificateTool/CertificateTool";
import Category2 from "./archive_project/Pages/Category/Category.jsx";
import ArtistProfile from "./routes/CertificateTool/ArtistProfile";
import { PhotoDetail, ProfileDetails } from "./components/Galary";
import ProductPage from "./components/Features/ProductPage/ProductPage.jsx";
import Reproduction from "./routes/Reproduction/Reproduction";
import ArchiveLanding from "./routes/ArchiveLanding/ArchiveLanding";
import { legacyText } from "./utils";
import { PhotoData } from "./components/Galary/Photo/PhotoData";
import ArchiveLanding2 from "./archive_project/Pages/ArchiveLanding2/ArchiveLanding2";
import ArchiveAccessGate from "./archive_project/Components/Common/ArchiveAccessGate/ArchiveAccessGate";
import Certificate from "./routes/Certificate/Certificate.jsx";
import { MARKET_ADDRESS } from "./components/Features/Market/Market.jsx";
import { MARKET_ABI } from "./contracts/contracts.js";
import PhysicalEdition from "./featured/HistoricalProject/Pages/PhysicalEdition.jsx";
import Posters from "./featured/HistoricalProject/Pages/Posters.jsx";


const Article = lazy(() => import("./routes/Article/Article"));
const Home = lazy(() => import("./routes/Home/Home"));
const NavBar = lazy(() => import("./components/Common/NavBar/NavBar"));
const MarketPage = lazy(() => import("./routes/MarketPage/MarketPage"));
const PhysicalAssets = lazy(() => import("./featured/Gallery/pages/PhysicalAssets/PhysicalAssets.jsx"));
const DigitalAssets = lazy(() => import("./featured/Gallery/pages/DigitalAssets/DigitalAssets.jsx"));
const Art = lazy(() => import("./routes/item/Arts/Art"));
const Artist = lazy(() => import("./routes/item/Artists/Artist"));
const NotFound = lazy(() => import("./routes/NotFound/NotFound"));
const PhyArt = lazy(() => import("./routes/item/Arts/PhyArt"));
const CoA = lazy(() => import("./featured/Resources/Pages/CoA.jsx"));
const Services = lazy(() => import("./featured/Resources/Pages/Services.jsx"));
const Verification = lazy(() => import("./featured/Resources/Pages/Verification.jsx"));
const AboutPage = lazy(() => import("./featured/AboutUs/Pages/About.jsx"));
// const CollaborationsPage = lazy(() => import("./featured/AboutUs/Pages/Collaborations.jsx"));
// const CollaborationArticlePage = lazy(() => import("./featured/AboutUs/Pages/CollaborationArticle.jsx"));

function App() {
  const location = useLocation();
  const [showCookieConsent, setShowCookieConsent] = useState(
    !localStorage.getItem("cookieConsent"),
  );
  const { state } = location;

  const isLoaPage =
    location.pathname.startsWith("/loa") ||
    location.pathname.startsWith("/certificate");

  const headerExcludedPages = [
    "/admin",
    "/archive-access",
    "/archive_Category",
    "/physical-assets",
    "/digital-assets",
  ];

  const footerExcludedPages = [
    "/archive_home",
    "/archive-access",
    "/archive_Category",
    "/admin",
    "/reproduction/collections",
    "/physical-assets",
    "/digital-assets",
  ];
  const isHeaderExcluded =
    isLoaPage ||
    headerExcludedPages.some((path) => location.pathname.startsWith(path));

  const isFooterExcluded =
    isLoaPage ||
    footerExcludedPages.some((path) => location.pathname.startsWith(path));

  const handleAcceptCookies = () => {
    localStorage.setItem("cookieConsent", "true");
    setShowCookieConsent(false);
  };

  return (
    <div className="App">
      <ToastContainer
        position="top-center"
        className="toast"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {!isLoaPage && showCookieConsent && (
        <div className="cookie-consent">
          <div className="cookie-consent__content">
            <p>
              We use cookies to improve your experience and personalize
              marketing. By clicking "Accept All", you agree to our{" "}
              <Link to={"/legal/terms-of-use"}>user policy</Link>.
            </p>
            <div className="cookie-consent__actions">
              <Link to={"/legal/terms-of-use"}>Manage Terms of Use</Link>
              <button onClick={handleAcceptCookies}>Accept All</button>
            </div>
          </div>
        </div>
      )}
      <Suspense fallback={<Preloader />}>
        {!isHeaderExcluded && <NavBar />}
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/digitals"
            element={<MarketPage key="nfts" marketType="nfts" />}
          />
          <Route
            path="/physicals"
            element={<MarketPage key="artwork" marketType="artwork" />}
          />
          <Route
            path="/physical-assets"
            element={<PhysicalAssets />}
          />
          <Route
            path="/digital-assets"
            element={<DigitalAssets />}
          />
          <Route
            path="/reproduction/:contract_address/:token_id"
            element={
              <ProductPage
                MARKET_ADDRESS={MARKET_ADDRESS}
                MARKET_ABI={MARKET_ABI}
              />
            }
          />
          <Route
            path="/creators"
            element={<MarketPage key="artist" marketType="artist" />}
          />
          <Route path="/media" element={<Media />} />
          <Route path="/media/:id" element={<Article />} />
          <Route
            path="/nft/:idhex"
            element={
              <DataWrapper
                key={window.location.pathname}
                type="nft"
                Component={Art}
              />
            }
          />
          <Route
            path="/artist/:idhex"
            element={
              <DataWrapper
                key={window.location.pathname}
                type="artist"
                Component={Artist}
              />
            }
          />
          <Route
            path="/artwork/:idhex"
            element={
              <DataWrapper
                key={window.location.pathname}
                type="artwork"
                Component={PhyArt}
              />
            }
          />
          {/* <Route path="/fashion" element={<Fashion />} /> */}
          {/* <Route path="/fashion_tool" element={<FashionTool />} /> */}
          <Route path="/about" element={<AboutPage />} />
          {/* <Route path="/collaborations" element={<CollaborationsPage />} />
          <Route
            path="/collaborations/:article_hash"
            element={<CollaborationArticlePage />}
          /> */}
          {/* Routes for the extracted blocks - declared in src/routesConfig.jsx,
              which is also where /profile's auth guard is applied. */}
          {appRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
          <Route path="/logout" />
          <Route path="/services" element={<Services />} />
          <Route
            path="/legal/:section"
            element={
              <Legal
                sections={legacyText}
                defaultSection={legacyText[0]}
                basePath="/legal"
              />
            }
          />
          <Route
            path="/legal"
            element={
              <Legal
                sections={legacyText}
                defaultSection={legacyText[0]}
                basePath="/legal"
              />
            }
          />
          <Route path="*" element={<NotFound />} />
          {/* <Route path="/password_reset" element={<ResetPasswordPage />} />
              ResetPasswordPage now lives in featured/User/pages/Auth. */}
          <Route
            path="/loa/:contractAddress/:tokenId/:artist_id"
            element={<Letter />}
          />
          <Route path="/certificate-tool" element={<CertificateTool />} />
          <Route path="/verify-profile" element={<ArtistProfile />} />
          <Route path="/GazaPhoto" element={<Galllary />} />
          <Route path="/GazaPhoto/:id" element={<PhotoDetail />} />{" "}
          <Route
            path="/profile/:name"
            element={
              <ProfileDetails photographerName={state?.name} data={PhotoData} />
            }
          />
          <Route path="/reproduction/collections" element={<Category />} />
          <Route path="/reproduction" element={<Reproduction />} />
          <Route path="/physical-editions" element={<PhysicalEdition />} />
          <Route path="/posters" element={<Posters />} />
          <Route path="/archive" element={<ArchiveLanding />} />
          <Route path="/archive_home" element={<ArchiveLanding2 />} />
          <Route path="/archive-access" element={<ArchiveAccessGate />} />
          <Route path="/archive_Category" element={<Category2 />} />
          <Route
            path="/certificate/:contractAddress/:tokenId"
            element={<Certificate />}
          />
          <Route path="/certificate/:seed" element={<Certificate />} />
          <Route path="/CoA" element={<CoA />} />
          <Route path="/verification" element={<Verification />} />
        </Routes>
        {!isFooterExcluded && <Footer />}
      </Suspense>
    </div>
  );
}

function DataWrapper({ type, Component }) {
  const [loading, setLoading] = useState(true);
  const [pageID, setPageID] = useState();
  const { idhex } = useParams();
  const [name, id] = idhex.split("-");

  useEffect(() => {
    setPageID(id);
  }, [id]);

  const fetchData = useToFindItem(type, pageID);

  useEffect(() => {
    if (fetchData) {
      setLoading(false);
    }
  }, [fetchData]);

  if (loading) {
    return <Preloader />;
  }
  return <Component data={fetchData} />;
}

export default App;
